import { render, staticRenderFns } from "./ConfigTreatment.vue?vue&type=template&id=1a937094"
import script from "./ConfigTreatment.vue?vue&type=script&lang=js"
export * from "./ConfigTreatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports